import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { cleanMaskedNumber } from '@/utilities'
import { handleError } from '@/store/handle-error'

export const PEParentsCardActions = {
  initPeParentsCard: ({ commit }, index) => {
    commit('setPeParentsCardLock', { index, lock: true })
  },
  peParentsCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        parents: {
          party_id: party.id,
          first_name: section.first_name,
          middle_name: section.middle_name,
          last_name: section.last_name,
          dob: section.dob,
          uncertain_dob: section.uncertain_dob,
          gender_id: section.gender_id,
          birth_country_id: section.birth_country_id,
          residence_country_id: section.residence_country_id,
          city_of_birth: section.city_of_birth,
          state_of_birth: section.state_of_birth,
          deceased: section.deceased,
          a_number: cleanMaskedNumber(section.a_number),
          no_a_number: section.no_a_number,
          immigration_status: section.immigration_status,
          relation: section.relation,
          monthly_income: section.monthly_income,
          income_verification: section.income_verification,
          resides_with_id: section.resides_with_id,
          dependent_of_id: section.dependent_of_id,
          created_at: section.created_at,
          updated_at: section.updated_at,
          linked_party_id: section.linked_party_id,
          immigration_status_other: section.immigration_status_other,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeParentsCardLock', { index, lock: true })
        commit('pePatchParty', {
          parents: updatedParty.parents || [],
        })
      }).
      catch(handleError)
  },
  peParentsCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/parents/${section.id}`).
      then(({ data }) => {
        commit('setPeParentsCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'parents',
          value: data,
        })
      }).
      catch(handleError)
  },
  peParentsCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        parents: {
          party_id: party.id,
          first_name: section.first_name,
          middle_name: section.middle_name,
          last_name: section.last_name,
          dob: section.dob,
          uncertain_dob: section.uncertain_dob,
          gender_id: section.gender_id,
          birth_country_id: section.birth_country_id,
          residence_country_id: section.residence_country_id,
          city_of_birth: section.city_of_birth,
          state_of_birth: section.state_of_birth,
          deceased: section.deceased,
          a_number: cleanMaskedNumber(section.a_number),
          no_a_number: section.no_a_number,
          immigration_status: section.immigration_status,
          relation: section.relation,
          monthly_income: section.monthly_income,
          income_verification: section.income_verification,
          resides_with_id: section.resides_with_id,
          dependent_of_id: section.dependent_of_id,
          created_at: section.created_at,
          updated_at: section.updated_at,
          linked_party_id: section.linked_party_id,
          immigration_status_other: section.immigration_status_other,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeParentsCardLock', { index, lock: true })
        commit('pePatchParty', {
          parents: updatedParty.parents || [],
        })
      }).
      catch(handleError)
  },
  peParentsCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          parents: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeParentsCardLock', { index, lock: true })
        commit('pePatchParty', {
          parents: updatedParty.parents || [],
        })
      }).
      catch(handleError)
  },
  peParentsCardAddSection: ({ commit }) => {
    commit('setPeParentsCardLock', { index: 'new', lock: false })
    commit('addPeParentsCardSection', {
      id: null,
      first_name: null,
      middle_name: null,
      last_name: null,
      dob: null,
      uncertain_dob: false,
      gender_id: null,
      birth_country_id: null,
      residence_country_id: null,
      city_of_birth: null,
      state_of_birth: null,
      deceased: null,
      a_number: null,
      no_a_number: null,
      immigration_status: null,
      relation: null,
      monthly_income: null,
      income_verification: null,
      resides_with_id: null,
      dependent_of_id: null,
      created_at: null,
      updated_at: null,
      linked_party_id: null,
      immigration_status_other: null,
    })
  },
}

export const PEParentsCardMutations = {
  setPeParentsCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ParentsCard) Vue.set(state.partyEdit.partySections, 'ParentsCard', {})
    Vue.set(state.partyEdit.partySections.ParentsCard, index, lock)
  },
  addPeParentsCardSection: (state, section) => {
    state.partyEdit.party.parents.push(section)
  },
  peParentsCardCreateUndo: state => state.partyEdit.party.parents.pop(),
}

export const PEParentsCardGetters = {
  peParentsCardLock: state => index => state.partyEdit.partySections.ParentsCard[index],
  peParentsCardHasNewSection: (_, getters) => !!getters.peParty.parents?.find(parent => parent.id === null),
}
